import { render, staticRenderFns } from "./Screen4-2.vue?vue&type=template&id=5451955f&scoped=true&lang=html&"
import script from "./Screen4-2.vue?vue&type=script&lang=js&"
export * from "./Screen4-2.vue?vue&type=script&lang=js&"
import style0 from "./Screen4-2.vue?vue&type=style&index=0&id=5451955f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451955f",
  null
  
)

export default component.exports